export const METRICS = [
  ["days_lived", "Giorni conclusi"],
  ["completed_full", "Passi completati"],
  ["completed_minimum", "Passi completati in forma breve"],
  ["not_completed", "Passi non svolti"],
  ["awaiting_confirmation", "Giorni che aspettano una risposta"],
  ["restarts", "Riprese dopo una pausa"],
];

export const STATUS_LABEL = {
  not_selected: "Nessun passo scelto",
  not_started: "Passo scelto, non ancora iniziato",
  in_progress: "Passo iniziato, non ancora finito",
  reduced_not_done: "Passo ridotto, in attesa di risposta",
  rescheduled: "Passo spostato, in attesa di risposta",
  completed_full: "Passo completato",
  completed_minimum: "Passo completato in forma breve",
  not_completed: "Passo non svolto",
};

export const DAY_STATUS = { done: "Concluso", today: "Oggi", pending: "In attesa di risposta", skipped: "Saltato", locked: "Si apre quel giorno", missed: "Da recuperare" };

export const SHORT_LABEL = "Se questo passo è troppo impegnativo, prova così:";

export const isCompleted = (s) => s === "completed_full" || s === "completed_minimum";

export const stepText = (rec) => (rec?.activeStep?.text || rec?.selectedStep?.text || "").trim();

export const modeLabel = (rec) => ({ minimum: "forma breve", custom: "versione ridotta" }[rec?.activeStep?.mode] || "");

export const hhmm = (iso, timeZone) => (iso ? new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone }) : "");
